import { get } from 'services/api/base';

import { GetPosesResponse } from './types-get-poses';

export function getPoses(): Promise<GetPosesResponse> {
  return get('v5/merchant/pos').json();
}
